<template>
  <div
    class="flex-shrink-0 w-8 h-8 font-medium flex items-center justify-center type-scale-n5 cursor-pointer relative select-none"
    :class="classes"
    @click="onClick"
  >
    <span :class="!this.schedule && 'opacity-25'">{{ day.dayOfMonth }}</span>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import format from '@/common/dateFormat'

export default {
  name: 'TimetableCell',

  props: {
    day: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    plans: get('migratedPlan/all'),

    activePlanId: get('migratedPlan/active'),

    activeOperator: get('trainSchedule/activeOperator'),

    activePlan() {
      return this.plans[this.activePlanId]
    },

    schedule() {
      return this.day.schedule
    },

    scheduleType() {
      const schedule = this.schedule
      return schedule && schedule.type
    },

    date() {
      return format(this.day.date)
    },

    active() {
      if (!this.scheduleType) return false
      return this.$store.get('timetable/selectedDateCell') === this.date
    },

    classes() {
      const type = this.scheduleType
      return [
        this.$style.root,
        this.active && this.$style.active,
        type === 'EJ' && 'bg-transparent',
        type === 'IH' && 'bg-red-50 text-white hover:bg-red-60',
        type === 'ID' && 'bg-purple-50 text-white hover:bg-purple-60',
        type === 'N' && 'bg-green-30 hover:bg-green-40 hover:text-white',
        type === 'A' && 'bg-blue-40 hover:bg-blue-50 text-white',

        this.active && type === 'EJ' && 'bg-white',
        this.active && type === 'IH' && 'text-white bg-red-60',
        this.active && type === 'ID' && 'text-white bg-purple-60',
        this.active && type === 'N' && 'bg-green-40 text-white',
        this.active && type === 'A' && 'bg-blue-50 text-white'
      ]
    }
  },

  methods: {
    onClick() {
      if (!this.scheduleType) return

      this.$store.set('timetable/selectedDateCell', this.date)
      const params = {
        tekniskttagnummer: this.$store.get('timetable/tekniskttagnummer'),
        date: this.date,
        planId: this.activePlan.sysid,
        sokande: this.activeOperator.sokande,
        operator: this.activeOperator.operator
      }
      this.$store.dispatch('trainChange/fetch', params)
    }
  }
}
</script>

<style lang="postcss" module>
.root:hover,
.active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.24);
  @apply z-10;
}

.active {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.24);
}

.active span {
  @apply type-scale-n2;
}

.root::after {
  content: '';
  @apply absolute border-r inset-0 pointer-events-none border-gray-20 opacity-25;
}
</style>
